// copied from Trello
// a 1x1 pixel image. Small to make the request fast
import { cfetch } from '@confluence/network';

const PROBABLY_OFFLINE_TIMEOUT = 5000;

export const getInternetConnectionState = async (): Promise<'healthy' | 'unhealthy'> => {
	// we can early return unhealthy if offline for navigator, but we cant if onLine.
	// That's because you can be online, but be waiting for VPN connection or something
	// else that blocks actually allowing internet.
	if (!navigator.onLine) {
		return 'unhealthy';
	}
	let timeoutId: NodeJS.Timeout | null = null;
	for (let i = 0; i < 3; i++) {
		try {
			const controller = new AbortController();
			timeoutId = setTimeout(() => controller.abort(), PROBABLY_OFFLINE_TIMEOUT);
			const response = await cfetch(`/_edge/tenant_info`, {
				cache: 'no-cache',
				method: 'HEAD',
				signal: controller.signal,
			});

			if (response.status >= 500 || response.status < 200) {
				return 'unhealthy';
			}
		} catch (err) {
			return 'unhealthy';
		} finally {
			if (timeoutId !== null) {
				clearTimeout(timeoutId);
			}
		}

		// stagger it a little because of flakey VPN's and firewalls
		await new Promise((res) => setTimeout(res, 1000));
	}

	// we got 3 good attempts, safe to say healthy
	return 'healthy';
};
